var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bold_info-circle",
    "data-name": "vuesax/bold/info-circle",
    transform: "translate(24 24) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "info-circle",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10,0A10,10,0,1,0,20,10,10.016,10.016,0,0,0,10,0ZM9.25,6a.75.75,0,0,1,1.5,0v5a.75.75,0,0,1-1.5,0Zm1.67,8.38a1.032,1.032,0,0,1-.21.33,1.155,1.155,0,0,1-.33.21.943.943,0,0,1-.76,0,1.155,1.155,0,0,1-.33-.21,1.032,1.032,0,0,1-.21-.33.942.942,0,0,1,0-.76.9.9,0,0,1,.54-.54,1,1,0,0,1,.76,0,.9.9,0,0,1,.54.54.942.942,0,0,1,0,.76Z",
    transform: "translate(2 2)",
    fill: "#09a047"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(24 24) rotate(180)",
    fill: "none",
    opacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoGreen);
export default __webpack_public_path__ + "static/media/info-green.b811e52aa343e3de074d5b27582f6ddf.svg";
export { ForwardRef as ReactComponent };